export default "__VITE_ASSET__exGaFzhy__"